/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PooledOrgOAuthAppInfo { 
    app_id: string;
    app_secret_path: string;
    authorization_timestamp: string;
    pooled_org_id: string;
}

